<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <v-card v-if="list_access">
      <div class="row mt-0">
        <div class="col-md-12">
          <div class="col-md-12" style="background:white; elevation-0">
            <div class="row pt-5">
              <div class="col-md-2 pt-0">
                <v-menu
                  ref="desde_selected"
                  v-model="desde_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="desde_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2 pt-0">
                <v-menu
                  ref="hasta_selected"
                  v-model="hasta_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="hasta_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="hasta_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="receiver_selected" autocomplete="off" item-text="name" item-value="id" :items="receivers" label="Receptor" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-6 pt-0" v-if="isProductCompany()">
                <label class="caption">Tipo de gasto:</label>
                <v-radio-group class="mt-0" v-model="stock_spent_selected" row>
                  <v-radio label="Con stock" :value="1" color="primary"></v-radio>
                  <v-radio label="Sin stock" :value="2" color="primary"></v-radio>
                  <v-radio label="Ambos" :value="3" color="primary"></v-radio>
                </v-radio-group>
              </div>

              <div class="col-md-10 pt-0">
                <label class="caption">Agrupar resultado por:</label>
                <v-radio-group class="mt-0" v-model="group_selected" row>
                  <v-radio v-if="isProductCompany()" label="Producto" :value="1" color="primary"></v-radio>
                  <v-radio label="Centro de Costo" :value="2" color="primary"></v-radio>
                  <v-radio label="Concepto" :value="3" color="primary"></v-radio>
                  <v-radio label="Centro de Costo y Concepto" :value="6" color="primary"></v-radio>
                  <v-radio label="Proveedor" :value="4" color="primary"></v-radio>
                  <v-radio label="Item del comprobante" :value="5" color="primary"></v-radio>
                </v-radio-group>
              </div>

              <div class="col-2 search-button-container">
                <v-btn color="info" class="" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="background:rgb(237,237,237); elevation-0">
        <div class="row">
          <div class="col-12">
            <!-- Botón para abrir el modal de filtros -->
            <v-btn color="info" text @click="openFilterModal" small>+ Agregar filtros adicionales</v-btn>

            <!-- Chips que muestran los filtros seleccionados -->
            <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" close @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
          </div>
        </div>

        <v-dialog v-model="dialog_filters" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Filtros</span>
            </v-card-title>

            <v-card-text>
              <div class="row mt-4">
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="supplier_selected"
                    autocomplete="off"
                    data-vv-as="supplier_selected"
                    name="supplier_selected"
                    item-text="name"
                    item-value="id"
                    :items="suppliers"
                    label="Proveedor"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0" v-if="isProductCompany()">
                  <v-combobox
                    v-model="product_selected"
                    autocomplete="off"
                    data-vv-as="product_selected"
                    name="product_selected"
                    item-text="label"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0" v-if="isProductCompany()">
                  <v-combobox
                    v-model="type_product_selected"
                    autocomplete="off"
                    data-vv-as="type_product_selected"
                    name="type_product_selected"
                    item-text="name"
                    item-value="id"
                    :items="product_types"
                    label="Tipo de producto"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0" v-if="isProductCompany()">
                  <v-combobox v-model="category_selected" autocomplete="off" item-text="name" item-value="id" :items="categories" label="Rubro de producto" multiple small-chips clearable></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="cost_center_selected"
                    autocomplete="off"
                    data-vv-as="cost_center_selected"
                    name="cost_center_selected"
                    item-text="name"
                    item-value="id"
                    :items="costs_centers"
                    label="Centro de costos"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-12 pt-0">
                  <v-combobox
                    v-model="concepto_selected"
                    autocomplete="off"
                    data-vv-as="concepto_selected"
                    name="concepto_selected"
                    item-text="name"
                    item-value="id"
                    :items="conceptos"
                    label="Concepto"
                    multiple
                    small-chips
                    clearable
                  ></v-combobox>
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- Botones para aplicar o cancelar filtros -->
              <v-btn color="error" text @click="closeFilterModal">Cancelar</v-btn>
              <v-btn color="success" text @click="filter">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
    <v-card v-if="list_access" class="mt-3">
      <v-card-title>
        <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :loading="loading"
        loading-text="Cargando..."
        :options="{
          descending: true,
          itemsPerPage: 15,
        }"
        @pagination="updatePagination"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, -1],
        }"
      >
        <template v-slot:item="props">
          <tr>
            <td v-if="hasOwnProperty(props.item, 'cbte_fch')">{{ props.item.cbte_fch }}</td>
            <td v-if="hasOwnProperty(props.item, 'spent_number_label')">{{ props.item.spent_number_label }}</td>
            <td v-if="hasOwnProperty(props.item, 'product_name')">{{ props.item.product_name != null ? props.item.product_name : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'descripcion')">{{ props.item.descripcion }}</td>
            <td v-if="hasOwnProperty(props.item, 'receiver_name')">{{ props.item.receiver_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'cost_center_name')">{{ props.item.cost_center_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'concepto_name')">{{ props.item.concepto_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'supplier_name')">{{ props.item.supplier_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'supplier_type')">{{ props.item.supplier_type != null ? props.item.supplier_type : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'sku')">{{ props.item.sku }}</td>
            <td v-if="hasOwnProperty(props.item, 'name')">{{ props.item.name }}</td>
            <td v-if="hasOwnProperty(props.item, 'category')">{{ props.item.category }}</td>
            <td v-if="hasOwnProperty(props.item, 'subcategory')">{{ props.item.subcategory }}</td>
            <td v-if="hasOwnProperty(props.item, 'quantity')" class="text-right">{{ formatUtils.formatNumber(props.item.quantity) }}</td>
            <td v-if="isProductCompany() && hasOwnProperty(props.item, 'total_weight')" class="text-right">
              {{ props.item.total_weight > 0 ? props.item.total_weight + " " + props.item.weight_unit : "-" }}
            </td>
            <td v-if="hasOwnProperty(props.item, 'total_sin_iva')" class="text-right">{{ formatUtils.formatPrice(props.item.total_sin_iva) }}</td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            {{ "Busqueda sin resultados - " + search }}
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import { emmiterService } from "@/libs/ws/emmiterService";
import { salesmanService } from "@/libs/ws/salesmanService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";

export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin, SettingsMixin],
  data() {
    return {
      Constant: Constant,
      formatUtils: formatUtils,
      service: generalService,
      page_title: "Compras por producto",
      modal_title: "Compras por producto",
      originalHeader: null,
      headers: [
        {
          text: "Fecha comprobante",
          align: "left",
          sortable: true,
          value: "cbte_fch",
          visible: false,
        },
        {
          text: "N° comprobante",
          align: "left",
          sortable: true,
          value: "spent_number_label",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "product_name",
          visible: false,
        },
        {
          text: "Descripcion",
          align: "left",
          sortable: true,
          value: "descripcion",
          visible: false,
        },

        {
          text: "Receptor",
          align: "left",
          sortable: true,
          value: "receiver_name",
          visible: false,
        },

        {
          text: "Centro de Costo",
          align: "left",
          sortable: true,
          value: "cost_center_name",
          visible: false,
        },
        {
          text: "Concepto",
          align: "left",
          sortable: true,
          value: "concepto_name",
          visible: false,
        },

        {
          text: "Proveedor",
          align: "left",
          sortable: true,
          value: "supplier_name",
          visible: false,
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "supplier_type",
          visible: false,
        },
        {
          text: "SKU",
          align: "left",
          sortable: true,
          value: "sku",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "name",
          visible: false,
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category",
          visible: false,
        },
        {
          text: "Subrubro",
          align: "left",
          sortable: true,
          value: "subcategory",
          visible: false,
        },
        {
          text: "Cantidad",
          align: "right",
          sortable: true,
          value: "quantity",
          visible: false,
        },
        {
          text: "Peso total",
          align: "right",
          sortable: true,
          value: "total_weight",
          visible: false,
        },
        { text: "Total S/IVA", value: "total_sin_iva", align: "right", visible: false },
      ],
      list: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      group_selected: 1,
      stock_spent_selected: 3,
      supplier_selected: [],
      cost_center_selected: [],
      receiver_selected: null,
      concepto_selected: [],
      category_selected: [],
      type_product_selected: [],
      product_selected: [],
      receivers: [],
      suppliers: [],
      categories: [],
      salesmans: [],
      costs_centers: [],
      conceptos: [],
      product_types: [],
      products: [],
      selected_filters: [],
      dialog_filters: false,
    };
  },
  mounted() {
    this.originalHeader = JSON.parse(JSON.stringify(this.headers));
    this.setHeader();
    this.group_selected = this.isProductCompany() ? 1 : 2;
    this.loadList(this.service);
    this.loadSuppliers();
    this.loadCategories();
    this.loadReceivers();
    this.loadCostsCenter();
    this.loadConceptos();
    this.loadProducts();
    this.loadProductType();
  },
  methods: {
    setHeader() {
      var Header_Options = {
        1: ["sku", "name", "category", "subcategory", "quantity", "total_weight", "total_sin_iva"],
        2: ["cost_center_name", "total_sin_iva"],
        3: ["concepto_name", "total_sin_iva"],
        4: ["supplier_name", "supplier_type", "total_sin_iva"],
        5: ["cbte_fch", "spent_number_label", "supplier_name", "receiver_name", "descripcion", "product_name", "concepto_name", "cost_center_name", "quantity", "total_sin_iva"],
        6: ["cost_center_name", "concepto_name", "total_sin_iva"],
      };

      var Header_Product_Company = ["total_weight"];
      var visible = Header_Options[this.group_selected] || [];

      this.headers = this.originalHeader.filter((header) => {
        if (!visible.includes(header.value)) {
          return false;
        }
        if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
          return false;
        }
        return true;
      });
    },
    hasOwnProperty(obj, key) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return true;
      }
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        supplier: this.supplier_selected.length ? this.supplier_selected.map((supplier) => supplier.id) : null,
        cost_center: this.cost_center_selected.length ? this.cost_center_selected.map((cc) => cc.id) : null,
        concepto: this.concepto_selected.length ? this.concepto_selected.map((c) => c.id) : null,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        category: this.category_selected.length ? this.category_selected.map((category) => category.id) : null,
        type_product: this.type_product_selected.length ? this.type_product_selected.map((type) => type.id) : null,
        product: this.product_selected.length ? this.product_selected.map((product) => product.id) : null,
        group: this.group_selected,
        stock_spent: this.isProductCompany() ? this.stock_spent_selected.toString() : "2",
      };

      this.selected_filters = [
        {
          label: "Proveedor",
          value: this.supplier_selected.length ? this.supplier_selected.map((supplier) => (supplier.name.length > 20 ? supplier.name.substring(0, 20) + "..." : supplier.name)).join(", ") : null,
        },
        {
          label: "Producto",
          value: this.product_selected.length ? this.product_selected.map((product) => (product.name.length > 20 ? product.name.substring(0, 20) + "..." : product.name)).join(", ") : null,
        },
        {
          label: "Tipo de producto",
          value: this.type_product_selected.length ? this.type_product_selected.map((type) => (type.name.length > 20 ? type.name.substring(0, 20) + "..." : type.name)).join(", ") : null,
        },
        {
          label: "Rubro de producto",
          value: this.category_selected.length ? this.category_selected.map((category) => (category.name.length > 20 ? category.name.substring(0, 20) + "..." : category.name)).join(", ") : null,
        },
        {
          label: "Centro de costos",
          value: this.cost_center_selected.length ? this.cost_center_selected.map((cc) => (cc.name.length > 20 ? cc.name.substring(0, 20) + "..." : cc.name)).join(", ") : null,
        },
        {
          label: "Concepto",
          value: this.concepto_selected.length ? this.concepto_selected.map((c) => (c.name.length > 20 ? c.name.substring(0, 20) + "..." : c.name)).join(", ") : null,
        },
      ].filter((filter) => filter.value);

      this.dialog_filters = false;

      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },
    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.label === "Proveedor") {
        this.supplier_selected = [];
      } else if (filtered.label === "Producto") {
        this.product_selected = [];
      } else if (filtered.label === "Tipo de producto") {
        this.type_product_selected = [];
      } else if (filtered.label === "Rubro de producto") {
        this.category_selected = [];
      } else if (filtered.label === "Centro de costos") {
        this.cost_center_selected = [];
      } else if (filtered.label === "Concepto") {
        this.concepto_selected = [];
      }

      this.filter();
    },
    loadReceivers() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.receivers = response.result;
      });
    },
    loadCostsCenter() {
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.costs_centers = response.result;
      });
    },
    loadConceptos() {
      generalService.filter({}, Constant.SECTION_CONCEPTOS).then((response) => {
        this.conceptos = response.result;
      });
    },
    loadSuppliers() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });
    },
    loadCategories() {
      generalService.filter({}, Constant.SECTION_CATEGORIES).then((response) => {
        this.categories = response.result;
      });
    },
    loadProducts() {
      generalService.filter({}, Constant.SECTION_PRODUCTS).then((response) => {
        this.products = response.result;
      });
    },
    loadProductType() {
      generalService.filter({}, Constant.SECTION_PRODUCT_TYPE).then((response) => {
        this.product_types = response.result;
      });
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .query(param, Constant.SECTION_REPORTS + "/compras-por-periodo")
        .then((response) => {
          this.setHeader();
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    exportFile() {
      var param = this.getFilterParams();
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/compras-por-periodo", param, "Compras-por-periodo.xlsx");
    },
  },
};
</script>

<style scoped>
.search-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
</style>